import NavProvider from "./contexts/NavContext";
import MarketplaceProvider from "./contexts/MarketplaceContext";
import DashboardListProvider from "./contexts/DashboardListContext";
import WorkspaceProvider from "./contexts/WorkspaceContext";
import AccountProvider from "./contexts/AccountContext";
import RoleProvider from "./contexts/RoleContext";
import ChartProvider from "./contexts/ChartContext";
import UserProvider from "./contexts/UserContext";
import AccountDataTableProvider from "./contexts/AccountDataTableContext";
import SampleDataTableProvider from "./contexts/SampleDataTableContext";
import CategoryProvider from "./contexts/CategoryContext";
import SelectedDashboardProvider from "./contexts/SelectedDashboardContext";
import { DashboardSlotsGlobalProvider } from "./contexts/DashboardSlots";
import { FullPageProvider } from "./contexts/FullPageContext";
import IntegrationsProvider from "./contexts/IntegrationContext";
import DataTableProvider from "./contexts/DataTableContext";
import { ModalProvider } from "./contexts/ModalContext";
import SettingProvider from "./contexts/SettingsContext";
import AccountSettingProvider from "./contexts/AccountSettingsContext";
import PermissionProvider from "./contexts/PermissionsContext";
import RolePermissionProvider from "./contexts/RolePermissionsContext";
import { DashPermissionProvider } from "./contexts/DashPermissionsContext";
import { DashboardUserSettingProvider } from "./contexts/DashboardUserSettingsContext";
import BannerProvider from "./contexts/BannerContext";
import { CubeDataContextProvider } from "./contexts/CubeDataContext";
import UniversalLoaderProvider from "./contexts/UniversalLoaderContext";
import MaintenanceProvider from "./contexts/MaintenanceContext";

const AppProvider = ({ children }) => {
    return (
        <NavProvider>
            <MarketplaceProvider>
                <WorkspaceProvider>
                    <DashboardListProvider>
                        <AccountProvider>
                            <UserProvider>
                                <RoleProvider>
                                    <ChartProvider>
                                        <AccountDataTableProvider>
                                            <SampleDataTableProvider>
                                                <CategoryProvider>
                                                    <SelectedDashboardProvider>
                                                        <DashboardSlotsGlobalProvider>
                                                            <FullPageProvider>
                                                                <IntegrationsProvider>
                                                                    <DataTableProvider>
                                                                        <ModalProvider>
                                                                            <SettingProvider>
                                                                                <AccountSettingProvider>
                                                                                    <PermissionProvider>
                                                                                        <RolePermissionProvider>
                                                                                            <DashPermissionProvider>
                                                                                                <DashboardUserSettingProvider>
                                                                                                    <BannerProvider>
                                                                                                        <CubeDataContextProvider>
                                                                                                            <UniversalLoaderProvider>
                                                                                                                <MaintenanceProvider>

                                                                                                                    {children}
                                                                                                                </MaintenanceProvider>
                                                                                                            </UniversalLoaderProvider>
                                                                                                        </CubeDataContextProvider>
                                                                                                    </BannerProvider>
                                                                                                </DashboardUserSettingProvider>
                                                                                            </DashPermissionProvider>
                                                                                        </RolePermissionProvider>
                                                                                    </PermissionProvider>
                                                                                </AccountSettingProvider>
                                                                            </SettingProvider>
                                                                        </ModalProvider>
                                                                    </DataTableProvider>
                                                                </IntegrationsProvider>
                                                            </FullPageProvider>
                                                        </DashboardSlotsGlobalProvider>
                                                    </SelectedDashboardProvider>
                                                </CategoryProvider>
                                            </SampleDataTableProvider>
                                        </AccountDataTableProvider>
                                    </ChartProvider>
                                </RoleProvider>
                            </UserProvider>
                        </AccountProvider>
                    </DashboardListProvider>
                </WorkspaceProvider>
            </MarketplaceProvider>
        </NavProvider>
    );
};

export default AppProvider;
